export default {"src":"/sitetest/_next/static/media/close_icon.a9b21515.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};